import { connect } from 'react-redux';

export function PreFlightCheck(props) {
  const { awsConnectionStatus, awsConnectionError, showError } = props;

  if (!showError) {
    return (
      <div className="uploader__pre-flight">
        <p>
          It appears the ChilliPharm pre-connection test encountered an issue and the uploader may not work correctly.
        </p>
        <p>
          Contact <a href="mailto:support@chillipharm.com">support@chillipharm.com</a> and please include the detailed
          error report below.
        </p>
      </div>
    );
  }
  return (
    <div className="uploader__pre-flight-error">
      <div className="alert alert-danger" role="alert">
        <span>Response</span>
        <h4>{awsConnectionStatus} Message</h4>
        {JSON.stringify(awsConnectionError, null, 2)}
      </div>
    </div>
  );
}

export const mapStateToProps = (state) => {
  return {
    awsConnectionStatus: state.internal.awsConnectionStatus,
    awsConnectionError: state.internal.awsConnectionError,
  };
};

export default connect(mapStateToProps)(PreFlightCheck);
